import { render, staticRenderFns } from "./use-detail.vue?vue&type=template&id=083ea6ce&scoped=true"
import script from "./use-detail.vue?vue&type=script&lang=js"
export * from "./use-detail.vue?vue&type=script&lang=js"
import style0 from "./use-detail.vue?vue&type=style&index=0&id=083ea6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ea6ce",
  null
  
)

export default component.exports